const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_dynamicLayout/events.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { loadMobileEventsContent, preloadMobilePage } from "@/react/components/Mobile/utils/mobilePageLoaders";
export const Route = createFileRoute("/_protected/_dynamicLayout/events")({
  loader: preloadMobilePage(loadMobileEventsContent),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});